// App.tsx
import React, { useMemo } from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./context/auth-context";
import { ThemeProvider } from "./context/ThemeContext";
import "leaflet/dist/leaflet.css";
import MainLayout from "./MainLayout";

const App: React.FC = () => {
  // ✅ Detecta qual domínio está acessando para manter a identidade visual
  const brand = useMemo(() => {
    const host =
      typeof window !== "undefined"
        ? window.location.hostname.toLowerCase()
        : "";

    const isLogvi = host.includes("logvi-havox.com");
    // Removido EVA já que agora você está migrando tudo para Logvi

    const systemName = isLogvi ? "Logvi" : "Logvi"; // Ajustado para Logvi como padrão
    const primary = isLogvi ? "#1f2908" : "#124280";

    return { host, isLogvi, systemName, primary };
  }, []);

  // Removida toda a lógica de TabGuard e useEffect de bloqueio

  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <MainLayout>
            <AppRoutes />
          </MainLayout>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
